import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import '../Raportee/datatable.css';
import {API_BASE_URL} from "../../apiConfig.jsx";

import * as XLSX from "xlsx";

function ComponentLinked() {
	const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);

	  const [userslist, setUserList] = useState([]);
	  const [subcategories, setSubcategories] = useState([]);
	  const [selectedUser, setselectedUser] = useState("");
	  const [subcat, setSubCat] = useState("");
	  const [columns, setColumns] = useState([]);
	  const [tabledata, settableData] = useState([]);
	  const [fromDate, setFromDate] = useState(null);
	  const [toDate, setToDate] = useState(null);
	
	
	  useEffect(() => {
		axios.post(`${API_BASE_URL}/api/custom/selectall`,
		{ t: strEncode('pmis_user_mst'), cols: strEncode("*") })
		  .then((response) => setUserList(response.data))
		  .catch((error) => console.error("Error fetching categories:", error));
	  }, []);
	 
	  const handleCategoryChange = (event) => {
		const userId = event.target.value;
		setselectedUser(userId)
	  };

	  const exportData = (type) => {
		const ws = XLSX.utils.json_to_sheet(tabledata);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };

	 const handleSubmit = async (e) => {
  e.preventDefault();

  // Build WHERE condition dynamically
  const conditions = [];
  if (selectedUser) {
    conditions.push(`id = '${selectedUser}'`);
  }
  if (fromDate) {
    conditions.push(`created >= '${fromDate.toISOString().split("T")[0]}'`);
  }
  if (toDate) {
    conditions.push(`created <= '${toDate.toISOString().split("T")[0]}'`);
  }

  const whereClause =
    conditions.length > 0 ? conditions.join(" AND ") + " GROUP BY clinkid" : "";

  try {
    const res = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
      t: strEncode("v_user_comp_link_data_summary"),
      cols: strEncode(
        "component as Composant, SUM(CASE WHEN data_entries_count > 0 THEN 1 ELSE 0 END) AS STATU"
      ),
      whrc: strEncode(whereClause),
    });

    // Format columns directly from response
    const columnKeys = Object.keys(res.data[0] || {});
   const formattedColumns = columnKeys.map((key) => ({
		name: key.charAt(0).toUpperCase() + key.slice(1),
		selector: (row) => row[key],
		sortable: true,
		cell: (row) => {
			// Custom logic: if val > 0 show "Entered", else "Not"
			if (key === "STATU") {
			return row[key] > 0 ? "Signalé" : "Non Signalé";
			}
			return row[key];
		},
		}));

    setColumns(formattedColumns);
    settableData(res.data);
  } catch (error) {
    console.error("Error fetching subcategories:", error);
  }
};	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">Raportee</Link></li>
				<li className="breadcrumb-item active"> État de collecte des données</li>
			</ol>
			<h1 className="page-header"> État de collecte des données</h1>
			<Panel>
				<PanelHeader> État de collecte des données (Seuls les composants liés seront vérifiés)
</PanelHeader>
				<PanelBody>
				<div className="col-xl-12">
				<form id="smart-form-register" className="row row-cols-lg-auto g-3 align-items-center" noValidate onSubmit={handleSubmit}>					
				        <div className="col-12">
				    	<label class="input">Sélectionner un utilisateur :</label>
						<select onChange={handleCategoryChange} class="form-select" value={selectedUser}>
							<option value="">Sélectionner un utilisateur</option>
							{userslist.map((usr) => (
							<option key={usr.id} value={usr.id}>{usr.c_name}</option>
							))}
						</select>
						</div>
						<div className="col-12">
							<label> Date de début </label>
							<DatePicker
								selected={fromDate}
								onChange={(date) => setFromDate(date)}
								dateFormat="yyyy-MM-dd"
								placeholderText="Date de début"
								name="from_date"
								className="form-control mb-5px"
							/>
							
							</div>
							<div className="col-12">
							<label>Date de fin </label>
							<DatePicker
								selected={toDate}
								onChange={(date) => setToDate(date)}
								dateFormat="yyyy-MM-dd"
								placeholderText="Date de fin"
								name="to_date"
								className="form-control mb-5px"
							/>
							</div>
								<div className="col-12 pull-right">
                                      <button type="submit" className="btn btn-sm btn-primary" style={{ margin:"20px" }}>
											Soumettre
											</button>

								  <button type="button"  onClick={() => exportData("xlsx")} className="btn btn-sm btn-success ">
								Exporter Excel
								</button>
							</div>
						 </form>
	                  <hr/>
						<div style={{margin:"10px"}}>
							
							<DataTable
									title="Données du rapport"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>
						</div>
						
			
				</div>
					
				</PanelBody>
			</Panel>
			
		</div>
	)
}

export default ComponentLinked;